"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkInstallationDirectoryProvider = void 0;
const IInstallationDirectoryProvider_1 = require("./IInstallationDirectoryProvider");
class SdkInstallationDirectoryProvider extends IInstallationDirectoryProvider_1.IInstallationDirectoryProvider {
    getInstallDir(installId) {
        return this.getStoragePath();
    }
}
exports.SdkInstallationDirectoryProvider = SdkInstallationDirectoryProvider;
//# sourceMappingURL=SdkInstallationDirectoryProvider.js.map